// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { navigationDrawerStyles } from "@synd/Overrides/Components/NavigationDrawer";
import { HEADER_HEIGHT_CSS_VAR } from "@synd/XDL/constants";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

navigationDrawerStyles.menuTriggerButton = {
    variant: "link" as any,
    css: css`
        width: 30px;
        height: 30px;
        &&&:not(:disabled) {
            &,
            & ${IconWrapper} {
                color: ${color("common.ui9")};
            }
        }
    `,
};

navigationDrawerStyles.drawer = {
    size: 360,
    cssOverrides: {
        drawerBody: css`
            top: var(${HEADER_HEIGHT_CSS_VAR});
            transform: translate(-100%, 0);
            height: calc(100vh - calc(var(${HEADER_HEIGHT_CSS_VAR}) + 1px));
            height: calc(100svh - calc(var(${HEADER_HEIGHT_CSS_VAR}) + 1px));
            box-shadow: none;
            padding: 16px 0;
            background-color: ${color("common.ui1")};
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
        drawerTitle: css`
            display: none;
        `,
        scrim: css`
            background-color: ${color("common.black", 0.5)};
            top: var(${HEADER_HEIGHT_CSS_VAR});
            height: calc(100vh - calc(var(${HEADER_HEIGHT_CSS_VAR})));
            height: calc(100svh - calc(var(${HEADER_HEIGHT_CSS_VAR})));
        `,
    },
};

navigationDrawerStyles.drawerSectionWrapper = {
    css: css`
        &.social-links-container .social-links {
            align-items: start;
            justify-content: start;
            flex-direction: column;
            gap: 16px;
            & > div {
                padding: 0px 16px;
                width: 100%;
            }
            & > span {
                display: none;
            }
            .social-link-label {
                color: ${color("common.ui6")};
            }
            a,
            a > ${TypographyStyle} {
                color: ${color("common.ui7")};
                font-size: ${fontConfig.small.size}px;
                line-height: ${fontConfig.small.lineHeight};
                font-weight: ${fontConfig.weight.regular};
                &:hover {
                    color: ${color("common.ui10")};
                }
            }
            .social-link-label + a {
                &,
                & > ${TypographyStyle} {
                    color: ${color("primary")};
                    font-size: ${fontConfig.xSmallSingleLine.size}px;
                    line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                    font-weight: ${fontConfig.weight.medium};

                    &:hover {
                        color: ${color("common.brand03")};
                    }
                }
                & > ${IconWrapper} {
                    color: ${color("primary")};
                }
            }
        }
        .actions-container {
            display: flex;
            flex: 1;
            gap: 36px;
            padding: 0 16px 8px;
        }
    `,
};

navigationDrawerStyles.mainNavigationRow = {
    css: css`
        &.secondary-nav {
            text-transform: uppercase;
        }
        &.shipTo-address-row {
            padding: 8px 16px 8px 16px;
        }
    `,
};

navigationDrawerStyles.accountPanelSectionWrapper = {
    css: css`
        width: 100%;
        text-align: start;
    `,
};

navigationDrawerStyles.mainNavigationRowTypography = {
    color: "common.ui7",
    weight: fontConfig.weight.regular,
    size: fontConfig.smallSingleLine.size,
    lineHeight: fontConfig.smallSingleLine.lineHeight,
};

navigationDrawerStyles.drawerSectionSeparator = {
    css: css`
        margin: 8px 16px;
        background-color: ${color("common.border")};
        height: 1px;
        width: calc(100% - 32px);
    `,
};

navigationDrawerStyles.signOutButton = {
    typographyProps: {
        size: fontConfig.xSmall.size,
        lineHeight: fontConfig.xSmall.lineHeight,
        weight: fontConfig.weight.bold,
    },
};

navigationDrawerStyles.panelMenu = {};
